import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hoc/EnvProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/jobs/GateWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/selectors/Page/DynamicFavicon.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
